import { render, staticRenderFns } from "./FullscreenLayout.vue?vue&type=template&id=526710f2&scoped=true&"
import script from "./FullscreenLayout.vue?vue&type=script&lang=js&"
export * from "./FullscreenLayout.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenLayout.vue?vue&type=style&index=0&id=526710f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526710f2",
  null
  
)

export default component.exports